<template>
	<div class="card">
		<div class="card-header bg-dark">
			<h3 class="mb-3 text-white">
				รายการแก้ไข
				<small class="ml-1">({{ data.length | format(0) }} ครั้ง)</small>
			</h3>

			<div class="row">
				<div class="col-md-3 col-6">
					<base-input label="วันที่" labelClasses="text-white">
						<flat-picker class="form-control datepicker" v-model="startDate" />
					</base-input>
				</div>
				<div class="col-md-3 col-6">
					<base-input label="ถึง" labelClasses="text-white">
						<flat-picker class="form-control datepicker" v-model="endDate" />
					</base-input>
				</div>
				<div class="col-md-3 col-6">
					<base-input label="ประเภท" labelClasses="text-white">
						<el-select class="select-primary mr-2" v-model="searchType">
							<el-option class="select-primary" label="ทั้งหมด" value="" />
							<el-option class="select-primary" label="ธนาคารไม่รัน" value="bank" />
							<el-option
								class="select-primary"
								label="ทรูมันนี่วอลเล็ทไม่รัน"
								value="tw"
							/>
							<el-option class="select-primary" label="เติมเครดิต" value="add" />
							<el-option class="select-primary" label="ตัดเครดิต" value="sub" />
						</el-select>
					</base-input>
				</div>
			</div>
		</div>

		<el-table row-key="id" header-row-class-name="thead-light" :data="queriedData">
			<el-table-column label="สมาชิก" min-width="150px">
				<div slot-scope="{ row }">
					<router-link :to="`/dashboard/members?search=${row.member.phone}`">
						{{ row.member.firstName }} {{ row.member.lastName }}
					</router-link>
					<br />
					{{ row.member.phone }}
				</div>
			</el-table-column>
			<el-table-column label="ประเภท" min-width="150px" align="center">
				<div slot-scope="{ row }">
					<span class="badge badge-success" v-if="row.type === 'add'">
						เติมเครดิต
					</span>
					<span class="badge badge-danger" v-else-if="row.type === 'deduct'">
						ตัดเครดิต
					</span>
					<span class="badge badge-warning" v-else-if="row.transferFrom === 'TRUEWALLET'">
						ทรูมันนี่วอลเล็ทไม่รัน
					</span>
					<span class="badge badge-primary" v-else>
						ธนาคารไม่รัน
					</span>
				</div>
			</el-table-column>
			<el-table-column label="จำนวน" min-width="150px">
				<div slot-scope="{ row }">
					{{ row.amount | format }}
				</div>
			</el-table-column>
			<el-table-column label="รายละเอียด" min-width="200px">
				<div slot-scope="{ row }">
					{{ row.remark }}
					<small class="d-block text-muted" v-if="row.operator">
						ผู้ทำรายการ: {{ row.operator }}
					</small>
				</div>
			</el-table-column>
			<el-table-column label="วันที่/เวลา" min-width="175px">
				<div slot-scope="{ row }">
					{{ row.createdAt | moment('DD/MM/YYYY HH:mm') }}
					<small class="d-block text-muted" v-if="row.transferTime">
						เวลาโอนเงิน: {{ row.transferTime | moment('DD/MM/YYYY HH:mm') }}
					</small>
				</div>
			</el-table-column>
		</el-table>

		<div class="card-footer border-0 d-flex justify-content-between">
			<p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>

			<base-pagination
				:per-page="pagination.perPage"
				:total="total"
				v-model="pagination.currentPage"
			/>
		</div>
	</div>
</template>

<script>
import { Table, TableColumn, Select, Option } from 'element-ui'
import { BasePagination } from '../../components'
import flatPicker from 'vue-flatpickr-component'

import moment from 'moment'
import tablePagination from '../../mixins/tablePagination'

export default {
	props: ['data'],
	mixins: [tablePagination(['bankType', 'bankAccount', 'amount', 'remark', 'createdAt'], 25)],
	components: {
		BasePagination,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Select.name]: Select,
		[Option.name]: Option,
		flatPicker,
	},
	data() {
		return {
			startDate: moment().format('YYYY-MM-DD'),
			endDate: moment().format('YYYY-MM-DD'),
			searchType: '',
		}
	},
	methods: {
		filterType(data) {
			const v = this.searchType
			return data.filter((x) => {
				if (v === 'bank') {
					return x.type === 'deposit' && x.transferFrom !== 'TRUEWALLET'
				} else if (v === 'tw') {
					return x.type === 'deposit' && x.transferFrom === 'TRUEWALLET'
				} else if (v === 'add') {
					return x.type === 'add'
				} else if (v === 'sub') {
					return x.type === 'deduct'
				} else {
					return true
				}
			})
		},
	},
	created() {
		this.$emit('reload', {
			start: this.startDate,
			end: this.endDate,
		})
		this.updateTableData(this.filterType(this.data))
	},
	watch: {
		data(v) {
			this.updateTableData(this.filterType(v))
		},
		startDate() {
			this.$emit('reload', {
				start: this.startDate,
				end: this.endDate,
			})
		},
		endDate() {
			this.$emit('reload', {
				start: this.startDate,
				end: this.endDate,
			})
		},
		searchType() {
			this.updateTableData(this.filterType(this.data))
		},
	},
}
</script>
